
import menu from './menu'
import fixed from './fixed'

const config = {
    menu,    // 菜单信息
    fixed    // 本地固定数据
};

export default config;